import AppConfig from "@/_config/application-config";
import childRoutes from "@/apps/aspScorecard/routes/index.js";
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const namespace = "aspScorecard";
const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  // "namespace" : {
  name: "Governance Scorecard",
  namespace,
  description: null,
  version: "1.1",
  icon: "mdi-alpha-r-circle-outline",
  parentRoute: "/aspScorecard",
  accentColor: "red",
  childRoutes,
  defaultRoute: "apphome", // "allmysurveys",
  component: () => import("@/apps/aspScorecard/Application.vue" ),
  settings: {
    //Development
    // api_url: "https://api.nonprd.lyb.com/external/asppsc-dev/api/",
    // client_id: "0b1f293b-08b3-4d72-8864-ae94f0ade13e",  
    // scope: "api://0b1f293b-08b3-4d72-8864-ae94f0ade13e/Read.All",
    //staging
    api_url: "https://api.nonprd.lyb.com/external/asppsc-stg/api/",
    client_id: "faa2ebf4-a872-43c3-a5d7-cf5dd3e0aa7c",  
    scope: "api://faa2ebf4-a872-43c3-a5d7-cf5dd3e0aa7c/Read.All",
    authorize_url: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    token_url: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    logout_url: "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080",
    redirect_uri: window.location.origin, //Gets the current
    autologin: true,
    debug: false,
    currentTime: null,
    currentTimeInterval: null,
    //azure_deployed: 1,
    navigation: [ 
      {
        icon: "mdi-view-list-outline",
        text: "Vendor Management",
        link: "/aspScorecard/vendormanagement",
        roles: ["SuperAdmin"]
      },
      {
        icon: "mdi-account-multiple-outline",
        text: "User Management",
        link: "/aspScorecard/usermanagement",
        roles: ["SuperAdmin"]
      },
      {
        icon: "mdi-application-edit-outline",
        text: "Edit Template",
        link: "/aspScorecard/edittemplate",
        roles: ["SuperAdmin"]
      },
      {
        icon: "mdi-format-list-numbered",
        text: "Survey Tracking",
        link: "/aspScorecard/surveytracking",
        roles: ["SuperAdmin","CategoryManager"]
      },
      {
        icon: "mdi-application-edit-outline",
        text: "Create New Survey",
        link: "/aspScorecard/createnewsurvey",
        roles: ["SuperAdmin","CategoryManager"]
      },
      {
        icon: "mdi-format-list-numbered",
        text: "All My Surveys",
        link: "/aspScorecard/allmysurveys",
        roles: ["SuperAdmin","CategoryManager", "Stakeholder", "Supplier"]
      },      
    ],
  },
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    themeColor: {
      default: "red",
      storageMode: localStorage,
    },
    userInfo: {
      default: null,
      storageMode: localStorage,
    },
    isTrue: {
      default: true,
      storageMode: sessionStorage,
    },
  },
};

export default AppConfig.merge(appConfig);
